<mat-nav-list style="overflow: hidden;">
    <img [src]="createImgPath(imageServerPath)" (error)="onImgError($event)" alt="Logo" class="login-logo"
        routerLink="/inactiveAll/inactiveUser" />
    <mat-accordion>
        <mat-nav-list>
            <div class="nav-item active">
                <a class="nav-link" mat-list-item  routerLink="/inactiveAll/inactiveUser"
                    routerLinkActive="active-link" [routerLinkActiveOptions]="{ exact: true }">
                    <mat-icon class="nav-icon">home</mat-icon>
                    Dashboard
                </a>
            </div>

            <div class="nav-item">
                <mat-expansion-panel #vendorsPanel [class.mat-elevation-z0]="true">
                    <mat-expansion-panel-header routerLinkActive="active-list-item">
                        <mat-icon class="nav-icon">persons</mat-icon> Business Profile
                    </mat-expansion-panel-header>
                    <mat-nav-list>
                        <div class="nav-item">
                            <a mat-list-item routerLink="/inactiveAll/bankdetails" routerLinkActive="active-list-item">
                                <li>Bank Details</li>
                            </a>
                        </div>
                        <div class="nav-item">
                            <a mat-list-item routerLink="/inactiveAll/companydetails" routerLinkActive="active-list-item">
                                <li>Company Details</li>
                            </a>
                        </div>
                        <div class="nav-item">
                            <a mat-list-item routerLink="/inactiveAll/publicDetails" routerLinkActive="active-list-item">
                                <li>Public Details</li>
                            </a>
                        </div>
                        <div class="nav-item">
                            <a mat-list-item routerLink="/inactiveAll/productSetting" routerLinkActive="active-list-item">
                                <li>Product Settings</li>
                            </a>
                        </div>
                    </mat-nav-list>
                </mat-expansion-panel>
            </div>
           
        </mat-nav-list>
    </mat-accordion>
</mat-nav-list>